import { styled } from '@mui/material/styles'
import { Stack } from '@mui/material'
export const StackInfo = styled(Stack)(({ theme }) => ({ isServices }) => ({
  margin: ' 6rem 6rem 0',
  [theme.breakpoints.down(700)]: {
    margin: isServices ? '1rem !important' : '16rem 1rem 1rem 1rem',
  },
  [theme.breakpoints.down(600)]: {
    margin: isServices ? '1rem !important' : '12rem 1rem 1rem 1rem',
  },
  [theme.breakpoints.down(450)]: {
    margin: isServices ? '1rem !important' : '13rem 1rem 1rem 1rem',
  },
}))
